module.exports = __webpack_public_path__ + "img/logo.f65749cc.png";